// Module
var code = "<p class=\"p1 neumatic uppercase block-10__title huge-text\" data-huge-text-z=\"-0.01\"></p> <div class=\"block-10__image\"> <div class=\"image\"></div> <div class=\"block-10__image__caption\"> <div class=\"text\"></div> <div class=\"credits\"></div> </div> </div> ";
// Exports
export default code;